import {
  Box,
  Chip,
  LinearProgress,
  Pagination,
  Typography,
} from '@mui/material';
import {
  DataGrid,
  gridPageCountSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';
import localeText from 'utils/localeText';
import styles from './styles';

const Table = ({ rows = [], isNota = false, onDelete, onSubmit, loading }) => {
  const CustomPagination = () => {
    const gridRef = useGridApiContext();
    const count = useGridSelector(gridRef, gridPageCountSelector);
    return (
      <Pagination
        color="primary"
        count={count}
        onChange={(_, value) => gridRef?.current?.setPage(value - 1)}
      />
    );
  };

  return (
    <Box sx={styles?.container}>
      <DataGrid
        rows={rows}
        columns={[
          ...(isNota
            ? [
                {
                  field: 'conferencia',
                  headerName: 'Conferência',
                  width: 120,
                  sortable: false,
                  renderCell: ({ row }) => {
                    const quantidade_conferida =
                      row?.Conferidos?.reduce(
                        (acc, item) => acc + item?.quantidade || 0,
                        0
                      ) || 0;
                    const conferido = row?.quantidade == quantidade_conferida;
                    const prm = { ...row, quantidade_conferida, conferido };

                    return (
                      <Chip
                        clickable
                        color="primary"
                        sx={styles?.chip}
                        variant={conferido ? 'contained' : 'outlined'}
                        label={conferido ? 'Conferido' : 'Conferir'}
                        size="small"
                        onClick={() => onSubmit(prm)}
                        onDelete={conferido && (() => onDelete(prm))}
                      />
                    );
                  },
                },
              ]
            : []),
          {
            field: 'referencia',
            headerName: 'Referência',
            width: 150,
            sortable: false,
          },
          {
            field: 'descricao',
            headerName: 'Produto',
            minWidth: 400,
            flex: 1,
            sortable: false,
          },
          {
            field: 'quantidade',
            headerName: 'Quantidade',
            type: 'number',
            width: 150,
            sortable: false,
            renderCell: ({ row }) => (
              <Typography variant="body2">
                {row?.quantidade} {row?.unidade_medida}
              </Typography>
            ),
          },
        ]}
        density="compact"
        disableColumnMenu
        showCellRightBorder
        showColumnRightBorder
        disableSelectionOnClick
        localeText={localeText}
        loading={loading}
        components={{
          LoadingOverlay: LinearProgress,
          Pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default Table;
